import React from 'react';
import Dashboard from '../pages/empleado/Dashboard';
import '../styles/Web.css';

function EmpleadoLayout({ usuario, onLogout }) {
  return (
    <Dashboard usuario={usuario} onLogout={onLogout} />
  );
}

export default EmpleadoLayout;
